module.exports = fox._r("fonts/museosanscyrl_1-webfont.woff", __webpack_public_path__ + "fonts/3okdb05.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_1-webfont.woff
// module id = 581
// module chunks = 2